module.exports = __webpack_public_path__ + "static/3-9edce6f4899176168d2885fa7f1c2083.jpg";